/****************************************************
 * Module Name:  RapnetUploadProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class RapnetUploadProxy {

    static createRapnetStone = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/rapnetstone",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static getAllRapnetStoneDetailByRapnetId = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/rapnetstone/detail`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static updateRapnetStone = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/rapnetstone`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static manualDeleteRapnetStone = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/rapnetstone/manual/delete`,
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static PerformRapnetUploadForSelectedStones = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/rapnetstone/rapnet/refresh/selected`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetUploadedRapnetStones = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/rapnetstone/rapnet/uploaded`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetRapnetAffectedStones = (lstStonetype, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/rapnet/affectedstones`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(lstStonetype),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}